module.exports = "https://portperrypedals.ca/_res/img/ray-hobbs.e44fc89.png";